import React from "react";
import { Box, Paper } from "../ui";

const LoadingPaper = React.memo(({ loader = false, children, sx = {},elevation= 0, ...rest }) => {
    return (
        <Box position="relative">
            <Paper
                elevation={elevation}
                sx={{
                    ...sx,
                }}
                {...rest}
            >
                {children}
            </Paper>

            {loader && (
                <Box
                    position="absolute"
                    top={0}
                    left={0}
                    width="100%"
                    height="100%"
                    bgcolor="rgba(255,255,255,0.2)"
                    display="flex"
                    alignItems="center"
                    justifyContent="center"
                    borderRadius={5}
                    zIndex={9999}
                >
                    <div style={{
                        width: 40,
                        height: 40,
                        border: "4px solid #ccc",
                        borderTop: "4px solid #1976d2",
                        borderRadius: "50%",
                        animation: "spin 1s linear infinite"
                    }} />
                    <style>
                        {`
          @keyframes spin {
            0% { transform: rotate(0deg); }
            100% { transform: rotate(360deg); }
          }
        `}
                    </style>
                </Box>
            )}
        </Box>
    );
});

export default LoadingPaper;
